export const currencydata = [
  "USD", // US Dollar
  "EUR", // Euro
  "GBP", // British Pound
  "INR", // Indian Rupee
  "JPY", // Japanese Yen
  "HKD", // Hong Kong Dollar
  "RMB", // Chinese Yuan Renminbi (was RMB)
  "KRW", // South Korean Won
  "AUD", // Australian Dollar
  "NZD", // New Zealand Dollar
  "CAD", // Canadian Dollar
  "CHF", // Swiss Franc
  "BRL", // Brazilian Real
  "MXN", // Mexican Peso
  "ZAR", // South African Rand
  "RUB", // Russian Ruble
  "SGD", // Singapore Dollar
  "MYR", // Malaysian Ringgit
  "IDR", // Indonesian Rupiah
  "PHP", // Philippine Peso
  "THB", // Thai Baht
  "TWD", // Taiwan Dollar
  "SAR", // Saudi Riyal
  "AED", // UAE Dirham
  "SEK", // Swedish Krona
  "NOK", // Norwegian Krone
  "DKK",  // Danish Krone
  "WON",
  "DONG"
];
